import React from 'react'
import styled from 'styled-components'
import { UIStyles } from '../../theme'
import FilterModuleContainer from '../../containers/DashboardContainers/FilterModuleContainer'
import DashboardViewerTogglerContainer from '../../containers/TopBar/DashboardViewerTogglerContainer'
import SearchViewContainer from '../../containers/SearchContainers/SearchViewContainer'
import ProfileContainer from '../../containers/UserContainers/ProfileContainer'
import { ReactComponent as LayersIcon } from '../../assets/img/layers-icon-mono.svg'
import { DisappearingTitle, Title } from '../UIComponents/titles'
import { useSelector } from 'react-redux'
import Organizations from '../../containers/OrganizationsContainer/Organizations'

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ currentLocation }) => {
  const accountsUser = useSelector(state => state.userLayers.user.data)
  return (
    <TopBarWrapper>
      <Logo />
      {(currentLocation.isDashboard || currentLocation.isViewer) && <SearchViewContainer />}
      {currentLocation.isDashboard && <FilterModuleContainer />}
      {currentLocation.isViewer && null}
      {currentLocation.isAccounts && <Organizations />}
      {currentLocation.isAccounts && (
        <Title>
          <DisappearingTitle text="Welcome back " timeout={5000} /> &nbsp; {`${accountsUser && accountsUser.name !== null ? accountsUser.name : ''}`}
        </Title>
      )}

      <RightMenu>
        {!currentLocation.isAccounts && (
          <DashboardViewerTogglerContainer
            isLayers={currentLocation.isViewer}
            isDashboard={currentLocation.isDashboard}
            isBiLabs={currentLocation.isBiLabs}
            isChat={currentLocation.isChat}
          />
        )}
        <ProfileContainer isCropMaster={currentLocation.isCropMaster} />
      </RightMenu>
    </TopBarWrapper>
  )
}

const TopBarWrapper = styled.div`
  position: sticky;
  display: flex;
  left: 0px;
  right: 0;
  top: 0;
  z-index: 10;
  height: 60px;
  background-color: ${UIStyles.deepblueColor3};
  border-bottom: 1px solid ${UIStyles.mintBorder};
`

// Same 44x44 footprint + 8px margin as the previous PNG; the padding sizes the glyph like before.
const Logo = styled(LayersIcon)`
  flex: none;
  box-sizing: border-box;
  width: 44px;
  height: 44px;
  padding: 2px;
  margin: 8px;
  color: ${UIStyles.whiteColor};
`

const RightMenu = styled.div`
  margin-right: 0;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  /* Above the dashboard filters, which overflow their box on narrow viewports and would otherwise
     sit on top of the page switcher and the user menu. */
  position: relative;
  z-index: 1;
`
